import { mapControlClassName } from '@/utils/map';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import classes from './information-control.module.css';

export function InformationControl({ position = ControlPosition.LEFT_BOTTOM }) {
  return (
    <MapControl position={position}>
      <div className={`${mapControlClassName} ${classes.information}`}>
        <p className={classes.detail}>Select a destination to see more details.</p>
        <p className={classes.subDetail}>All routes are approximate due to map resolution.</p>
      </div>
    </MapControl>
  );
}
